import sessionReader from '../store/readHelpers/SessionReader';
import viewReadyTracker from './ViewReadyTracker';

let idCounter = -1;

class LoadTracker {
    constructor(callback, context) {
        this.callback = callback;
        this.context = context || 'loading';
        this.isDead = false;
        this.pathname = viewReadyTracker.pathname;
        this.pendingItems = {};
        this.readyItems = {};
        this.erroredItems = {};
        this.allItemsAdded = false;
        this.id = ++idCounter;
        this.itemsCounter = 0;

        if (sessionReader.shouldDebugTrackers()) {
            this.setAllReadyTimeout();
        }
    }

    getPathname() {
        return this.pathname;
    }

    kill() {
        if (this.handle) {
            clearTimeout(this.handle);
        }
        this.isDead = true;
        this.pendingItems = {};

        delete this.callback;
    }

    setAllReadyTimeout(count = 1) {
        this.handle = setTimeout(() => {
            if (!this.isAllReady()) {
                console.log(`\n***************\nLoadTracker ${this.context} - ${this.id} not ready`, this);
            } else if (count < 10) {
                this.setAllReadyTimeout(count + 1);
            }
        }, 10000);
    }

    addItemToTrack = (itemDescription) => {
        if (this.isDead) {
            return () => undefined;
        }
        this.itemsCounter++;
        const id = `${this.id}.${this.itemsCounter}`;
        this.pendingItems[id] = `(${id}) ${itemDescription}`;
        return (success) => {
            if (!this.isDead) {
                this.updateItemStatus(success, id);
            }
        };
    };

    updateItemStatus(success, id) {
        if (this.pendingItems[id]) {
            if (success) {
                this.readyItems[id] = this.pendingItems[id];
            } else {
                this.erroredItems[id] = this.pendingItems[id];
            }
            delete this.pendingItems[id];
        }
        if (this.allItemsAdded && (this.isAllReady() || this.isAsReadyAsCanBe())) {
            this.callback(!this.hasErroredItems());
        }
    }

    setAllItemsAdded() {
        this.allItemsAdded = true;
        if (this.isAllReady() || this.isAsReadyAsCanBe()) {
            this.callback(!this.hasErroredItems());
        }
    }

    isAllReady() {
        return Object.keys(this.pendingItems).length === 0 && Object.keys(this.erroredItems).length === 0;
    }

    isAsReadyAsCanBe() {
        return Object.keys(this.pendingItems).length === 0;
    }

    hasErroredItems() {
        return Object.keys(this.erroredItems).length !== 0;
    }
}

export default LoadTracker;
